// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".unit-multiselect .multiselect__tags{border-radius:0 .2rem .2rem 0;background:#f1f2f3;min-height:45.4px!important;border:1px solid #bfc9d4}.unit-multiselect .multiselect__input,.unit-multiselect .multiselect__single{background:#f1f2f3}", ""]);
// Exports
module.exports = exports;
